import React, { useState,useEffect } from "react";
import PaymentMethods from "./pymentmethods";
import { Link } from "react-router-dom";

import { AffiliateDashboardData } from "../../../network/api/AffiliateDashboardData";
import { PayPalData } from "../../shop/components/gateways/network/api/PayPalData";
import ButtonLoader from "../../../../../../../components/ButtonLoader";

export default function WithdrawFunds({ setActiveTab,reload, setReload }) {
    const [selectedMethod, setSelectedMethod] = useState(null);
    const [withdrawAmount, setWithdrawAmount] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [termsAccepted, setTermsAccepted] = useState(false);

    const [isDashLoading, setIsDashLoading] = useState(false);
    const [dashData, setDashData] = useState(null);
    const [dashError, setDashError] = useState(null);

    let percentage = 0;
    if (dashData) {
        const balance = parseFloat(dashData.balance);
        const amount = parseFloat(withdrawAmount) || 0;
        percentage = balance > 0 ? (amount / balance) * 100 : 0;
    }

    
    useEffect(() => {
        const fetchDashboardData = async () => {
            try {
                setIsDashLoading(true);
                const response = await AffiliateDashboardData({ owner: null });
                if (response.status === "success") {
                    setDashData(response.data);
                } else {
                    setDashError(response.message);
                }
            }
            catch (error) {
                setDashError("An error occurred while fetching dashboard data.");
            } finally {
                setIsDashLoading(false);
            }
        }
        fetchDashboardData();


    }, [selectedMethod, reload]);

    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);

    const handleRequestPaymentWithdrawal = async () => {
        setIsLoading(true);
        setErrorMessage(null);
        try {
            if (!selectedMethod) {
                setErrorMessage("Please select a payment method.");
                return;
            }
            
            if (dashData && parseFloat(withdrawAmount) > parseFloat(dashData.balance)) {
                setErrorMessage("Insufficient balance for this withdrawal.");
                return;
            }

            const response = await PayPalData({
                mode:"withdraw",
                payload : {
                    amount: parseFloat(withdrawAmount).toFixed(2),
                    user_payment_method_id: selectedMethod.id,
                },
                via: selectedMethod.method,
            });

            if (response.status === "success") {
                setSubmitted(true);
                setTermsAccepted(false);
                setReload(!reload);
            }else {
                setErrorMessage(response.message || "An error occurred while processing your withdrawal request.");
            }

        } catch (error) {
            setErrorMessage("An error occurred while processing your request. Please try again later.");
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <div className="row" key={`withdraw-funds-sdfaasdf`}>
            <div className="col-12 col-lg-4">
                <div className="card custom-card shadow-sm">
                    <PaymentMethods setSelectedMethodObject={setSelectedMethod} />
                </div>
            </div>
            <div className="col-12 col-lg-8">
                <div className="card custom-card shadow-sm">
                    <div className="card-body d-flex justify-content-center align-items-center" >
                        <div className="w-100">
                            {isDashLoading ? (
                                <div className="text-center">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            ) : dashError ? (
                                <div className="text-center">
                                    <i className="fa fa-exclamation-triangle fa-3x text-danger mb-3"></i>
                                    <h4 className="mb-3 text-danger">Error Loading Dashboard</h4>
                                    <p>{dashError}</p>
                                    <button className="btn btn-primary mt-3" onClick={() => setReload(!reload)}>Retry</button>
                                </div>
                            ) : (
                                <>
                                    {!selectedMethod ? (
                                        <div className="text-center d-flex align-items-center justify-content-center" style={{ height: "100%" }}>
                                            <div>
                                                <h3 className="mb-3">Withdraw Funds</h3>
                                                <p className="text-muted">Select a payment method from the left to begin your withdrawal.</p>
                                                <i className="fa fa-hand-holding-usd fa-3x text-primary my-4"></i>
                                            </div>
                                        </div>
                                    ) : (
                                        !submitted ? (
                                            <div>
                                                <h4 className="card-title mb-4">Withdraw via {selectedMethod?.method }</h4>
                                                {errorMessage && (
                                                    <div className="alert alert-danger alert-dismissible fade show" role="alert">
                                                        <strong>Error!</strong> {errorMessage}
                                                    </div>
                                                )}

                                                <div className="mb-4">
                                                    <label className="form-label mb-2">Amount to Withdraw</label>
                                                    <div className="input-group mb-2">
                                                        <span className="input-group-text">$</span>
                                                        <input
                                                            type="text"
                                                            inputMode="decimal"
                                                            className="form-control"
                                                            placeholder="Enter amount"
                                                            value={withdrawAmount}
                                                            onChange={(e) => {
                                                                const val = e.target.value;
                                                                if (/^\d*\.?\d*$/.test(val) || val === '') {
                                                                    setWithdrawAmount(val);
                                                                }
                                                            }}
                                                        />
                                                        <button type="button" className="btn btn-outline-primary" onClick={() => setWithdrawAmount(Number(dashData?.balance ?? 0))}>Max</button>
                                                    </div>

                                                    <div className="progress" style={{ height: "8px", cursor: "pointer" }}
                                                        onClick={(e) => {
                                                            if (dashData) {
                                                                const rect = e.currentTarget.getBoundingClientRect();
                                                                const clickX = e.clientX - rect.left;
                                                                const clickedPercentage = clickX / rect.width;
                                                                const newAmount = (parseFloat(dashData.balance) * clickedPercentage).toFixed(2);
                                                                setWithdrawAmount(newAmount);
                                                            }
                                                        }}
                                                    >
                                                        <div
                                                            className="progress-bar"
                                                            role="progressbar"
                                                            style={{ width: `${percentage}%` }}
                                                            aria-valuenow={percentage}
                                                            aria-valuemin="0"
                                                            aria-valuemax="100"
                                                        ></div>
                                                    </div>

                                                    <small className="text-muted d-block mt-1">Available Balance: ${dashData?.balance ?? "0.00"}</small>
                                                </div>

                                                <div className="form-check mb-3">
                                                    <input className="form-check-input" type="checkbox" id="acceptTerms" checked={termsAccepted} onChange={(e) => setTermsAccepted(e.target.checked)} />
                                                    <label className="form-check-label" htmlFor="acceptTerms">
                                                        <Link to="/withdrawal-terms" className="text-primary" target="_blank">I accept the terms and conditions</Link>
                                                    </label>
                                                </div>

                                                <button
                                                    type="submit"
                                                    className="btn btn-primary w-100"
                                                    disabled={isLoading ||
                                                        !termsAccepted ||(
                                                        selectedMethod?.method === "licence" ? parseFloat(withdrawAmount) < 10 : parseFloat(withdrawAmount) < 100) ||
                                                        (dashData && (parseFloat(withdrawAmount) || 0) > parseFloat(dashData.balance))
                                                    }
                                                    onClick={() => handleRequestPaymentWithdrawal()}
                                                >
                                                    {isLoading ? <ButtonLoader /> : "Withdraw Funds"}
                                                </button>
                                            </div>
                                        ) : (
                                            <div className="text-center">
                                                <i className="fa fa-check-circle fa-3x text-success mb-3"></i>
                                                <h3 className="text-success mb-3">Withdrawal Submitted</h3>
                                                <p>You have requested to withdraw <strong>${(parseFloat(withdrawAmount) || 0).toFixed(2)}</strong> via <strong>{selectedMethod?.method}</strong>.</p>
                                                <p className="text-muted">You will receive a confirmation once it's processed.</p>
                                                <button className="btn btn-outline-primary mt-3" onClick={() => { setSubmitted(false); setWithdrawAmount(''); setReload(!reload); }}>
                                                    Make Another Withdrawal
                                                </button>
                                            </div>
                                        )
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}